export const round = (num, decimalPlaces) => {
	return +Number(num).toFixed(decimalPlaces)
}

// this may cause erors if we round in a  way that EXCLUDES the very outside numbers by accident, making them inaccessible
export const getDecimalPrecision = (rangeOfData) => {
	if (rangeOfData > 5) {
		return 2
	} else if (rangeOfData > 1) {
		return 3
	} else {
		return 4
	}
}

// rounds to visually sensible decimal place
export const smartRound = (num=0, min = false, max = false) => {
	min = min || num
	max = max || num
	if (Math.abs(min) > 100 || Math.abs(max) > 100)
		return round(num, 0)
	if (Math.abs(min) < 1 || Math.abs(max) < 1)
		return round(num, 3)
	if (Math.abs(min) < 10 && Math.abs(max) < 10)
		return round(num, 2)
	return round(num, 1)
}

// Add commas
export const addCommasToAndRoundNumbers = (x) => {
	return isNaN(x) ? x : (Math.round(x * 100) / 100).toLocaleString()
}

// converts an array of strs into a map keyed by strings, set to the same value
export const tableWithSameValue = (arr, value) => {
	const allValue = {}
	arr.forEach(c => {allValue[c] = value})
	return allValue
}

// check to see if all items in a list is in the lookup obj/dict
export const allItemsInLookup = (arr, lookup) => {
	const ok = arr.filter(a => a in lookup)
	return ok.length === arr.length
}

// create steps (typically used for colors)
export const createSteps = ({numSteps, min, max, roundTo=1}) => {
	const stepDist = (max - min) / (numSteps-1)
	const steps = []
	if (stepDist === 0) return [min]
	for (var i=0; i<numSteps; i++) {
		steps.push(smartRound(min + i * stepDist, min, max))
	}
	return steps
}

// like python range function
export const arrayRange = i => {
	return [...Array(i).keys()]
}

export const replaceUnderscoresWithSpaces = (str) => typeof str === 'string' ? str.replace(/_/g, ' ') : str

export const isEmpty = (obj) => {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false
    }
    return true
}

export const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index
}
